var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchinzaLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 878.211,
    height: 947.881,
    viewBox: "0 0 878.211 947.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5188",
    "data-name": "Path 5188",
    d: "M3005.188,2055.82l-303.613-657.058-202.068,440.5s42.605,38.328,96.429,58.319c42.792,15.894,100.35,13.553,100.35,13.553l-53.3-114.907,66.537-145.057,93.049,202.333,60.238,131.39a427.072,427.072,0,0,1-140.386,30.915l-3.175.153c-5.827.283-11.659.588-17.572.588-76.228,0-154.972-20.783-221.721-58.5l-29.551-16.705-52.342,114.481H2261.821s426.975-916.54,440.541-947.881c73.565,159.064,364.951,790.638,437.669,947.881Z",
    transform: "translate(-2261.82 -1107.939)",
    fill: "#383838",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchinzaLabel);
export default __webpack_public_path__ + "static/media/archinza-label.7c8838a45b8dc26e2d05f67f01cc3f3f.svg";
export { ForwardRef as ReactComponent };